export const normalizePermissions = (raw) => {
    const result = {};

    Object.keys(raw || {}).forEach(moduleName => {
        const moduleData = raw[moduleName];

        // Parent permissions
        result[moduleName] = {
            read: moduleData?.read || false,
            add: moduleData?.add || false,
            edit: moduleData?.edit || false,
            delete: moduleData?.delete || false,
            view_permission: moduleData?.view_permission || false
        };

        // Children permissions
        if (Array.isArray(moduleData?.children)) {
            moduleData.children.forEach(childObj => {
                const childName = Object.keys(childObj)[0];
                result[childName] = {
                    read: childObj[childName]?.read || false,
                    add: childObj[childName]?.add || false,
                    edit: childObj[childName]?.edit || false,
                    delete: childObj[childName]?.delete || false,
                    view_permission: childObj[childName]?.view_permission || false
                };
            });
        }
    });

    return result;
};

